import React from "react";
import { Row } from "antd";
import { JButton } from "../JButton";

export interface JCarouselSectionProps {
    title?: string;
    viewAll?: string;
    showViewAll?: boolean;
    children: any;
    className?: string;
    onClick: () => void;
}

export const JCarouselSection = ({title, viewAll, showViewAll = true, children,className, onClick }: JCarouselSectionProps) => {

    return (
        <div className={`carousel-webapp ${className}`}>
            <div
                className={`carousel-template`}>
                {(title || viewAll) && (
                    <div className="carousel-webapp-header">
                        {title && (
                            <label className="carousel-webapp-header-title">
                                {title}
                            </label>
                        )}
                        {showViewAll && viewAll && (
                            <JButton
                                type='link'
                                className="carousel-webapp-header-viewall"
                                onClick={() =>onClick()}
                            >
                                <Row><label>{viewAll}</label> &nbsp; <span className="viewAll-arrow">{">"}</span></Row>
                            </JButton>
                        )}
                    </div>
                )}
                <div className="carousel-section-content">{children}</div>
            </div>
        </div>
    );
};
